// Confort & outils utilisés en séance — présentation transparente du matériel
// que Jérémy amène ou utilise sur table. Certains items sont réservés au
// service à domicile (huiles essentielles, encens, expérience Aufguss).
export const COMFORT_TOOLS = [
    {
        id: "table-master",
        name: "Table Master — qualité professionnelle",
        icon: "BedDouble",
        context: "Clinique & domicile",
        description:
            "Table de massage de marque Master Massage Equipment (référence internationale des massothérapeutes professionnels) : rembourrage multi-couches haute densité, appui-visage réglable, largeur généreuse et stabilité irréprochable jusqu'à 300 kg. La même table est amenée à domicile — vous bénéficiez du confort clinique où que vous soyez, sans compromis.",
    },
    {
        id: "guasha-jade",
        name: "Guashas en pierre de jade",
        icon: "Gem",
        context: "Clinique & domicile",
        description:
            "Petits outils lisses en pierre de jade véritable utilisés pour raboter en douceur les tensions myofasciales, drainer la lymphe du visage, du cou et du dos, et relâcher les points gâchette. La fraîcheur naturelle du jade calme les inflammations locales et procure une sensation apaisante immédiatement reconnaissable.",
    },
    {
        id: "pad-chauffant",
        name: "Pad chauffant",
        icon: "Flame",
        context: "Clinique & domicile",
        description:
            "Coussin chauffant infrarouge placé sous le bas du dos ou les épaules pendant les moments où je travaille une autre zone. La chaleur douce (environ 40 °C) détend les muscles profonds, améliore la circulation locale et prépare les tissus à recevoir un travail plus profond sans résistance.",
    },
    {
        id: "coussin-epaule",
        name: "Coussin d'épaule",
        icon: "Sofa",
        context: "Clinique & domicile",
        description:
            "Petit coussin ergonomique glissé sous l'épaule ou l'aisselle pour libérer complètement la ceinture scapulaire lorsque vous êtes en position ventrale. Il évite l'écrasement du plexus brachial et permet un travail profond des trapèzes, du deltoïde et du grand rond sans tension résiduelle dans le bras.",
    },
    {
        id: "baton-thai",
        name: "Bâton thaï",
        icon: "Ruler",
        context: "Clinique & domicile",
        description:
            "Bâton de bois traditionnel utilisé en massage thaï pour appliquer une pression profonde le long des lignes d'énergie (sen), sur les cuisses, les mollets, le dos et la plante des pieds. Il permet un travail plus soutenu qu'avec les mains, tout en restant précis et parfaitement contrôlé.",
    },
    {
        id: "traversins",
        name: "Traversins & bolsters",
        icon: "AlignHorizontalJustifyCenter",
        context: "Clinique & domicile",
        description:
            "Traversins semi-fermes de tailles variées placés sous les genoux (position dorsale), les chevilles (position ventrale) ou entre les genoux (position latérale). Ils garantissent un alignement neutre de la colonne, un relâchement complet du bassin et un confort qui peut se prolonger 90 à 120 minutes sans engourdissement.",
    },
    {
        id: "bol-tibetain",
        name: "Bol tibétain",
        icon: "Bell",
        context: "Clinique & domicile",
        description:
            "Bol chantant traditionnel en alliage de sept métaux, joué à la main ou posé directement sur le corps. Les vibrations sonores basses fréquences traversent les tissus, activent le nerf vague et induisent en 30-60 secondes un état parasympathique profond. Signal d'ouverture et de clôture de la séance.",
    },
    {
        id: "tongue-drum",
        name: "Tongue drum",
        icon: "Music",
        context: "Clinique & domicile",
        description:
            "Tambour à langues en acier accordé sur une gamme pentatonique apaisante. Utilisé pendant les massages Signature et Enrichi pour créer un paysage sonore vivant, non enregistré, qui accompagne la respiration et ancre le mental dans le moment présent.",
    },
    {
        id: "huiles-essentielles",
        name: "Choix d'huiles essentielles",
        icon: "Droplet",
        context: "Domicile uniquement",
        description:
            "À votre domicile uniquement, vous choisissez avant la séance parmi une sélection d'huiles essentielles biologiques : lavande vraie (apaisement), petit grain bigarade (anxiété), ylang-ylang (détente profonde), eucalyptus (respiration), menthe poivrée (tonique). Diffusion en salle ou intégration ponctuelle aux huiles de massage.",
    },
    {
        id: "encens",
        name: "Bâtons d'encens artisanaux",
        icon: "Wind",
        context: "Domicile uniquement",
        description:
            "À domicile uniquement, sur demande : bâtons d'encens artisanaux (santal, bois de cèdre, nag champa, patchouli) brûlés quelques minutes avant la séance pour transformer l'espace. Une signature olfactive qui invite à ralentir dès l'entrée dans la pièce.",
    },
    {
        id: "aufguss",
        name: "Expérience Aufguss à domicile",
        icon: "ThermometerSun",
        image: "/tools/aufguss.webp",
        imageFallback: "/tools/aufguss.jpg",
        context: "Domicile · Californien & Signature uniquement",
        description:
            "Rituel inspiré des traditions nordiques : je diffuse à la main, à l'aide d'une serviette, des vagues d'air parfumé aux huiles essentielles autour de vous à des moments clés du soin. La chaleur, l'odeur et le mouvement d'air amplifient la respiration et créent une immersion sensorielle unique. Réservé aux massages Californien et Signature à domicile.",
    },
];
